import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useNotificationsListQuery } from "modules/AccountSettings/hooks";

import type { NotificationElement } from "models";

type GroupNotificationEntity = { title: string; templateId: number; elements: NotificationElement[] };

//TODO: Cleanup hook
export const useNotificationElements = () => {
  const { t } = useTranslation();

  const { notificationsList, isLoading: isLoadingNotifications } = useNotificationsListQuery();

  const [groupedNotificationElements, setGroupedNotificationElements] = useState<Record<any, GroupNotificationEntity>>({});

  const notificationElementsWithTranslations = useMemo(
    () =>
      notificationsList.map(element => ({
        ...element,
        entity: element.entity ? { ...element.entity, name: `v8_${element.entity.name}` } : element.entity,
        field: element.field ? { ...element.field, name: `v8_${element.field.name}` } : element.field
      })),
    [notificationsList]
  );

  const fetchNotificationElements = useCallback(async () => {
    if (isLoadingNotifications) return;
    try {
      const groupedNotificationElements: Record<any, GroupNotificationEntity> = {};
      notificationElementsWithTranslations.forEach(element => {
        if (!(element.notification_entity_id in groupedNotificationElements))
          groupedNotificationElements[element.notification_entity_id] = {
            title: element.entity?.name || "",
            templateId: element.entity?.template_id || 0,
            elements: []
          };
        else groupedNotificationElements[element.notification_entity_id].elements.push(element);
      });

      Object.values(groupedNotificationElements).forEach(group =>
        group.elements.sort((a, b) => (t(a.field?.name || "") || a.field?.name || "").localeCompare(t(b.field?.name || "") || b.field?.name || ""))
      );

      setGroupedNotificationElements(groupedNotificationElements);
    } catch (error) {
      console.error(`Error while fetching notification elements`, error);
    }
  }, [isLoadingNotifications, notificationElementsWithTranslations]);

  useEffect(() => {
    fetchNotificationElements();
  }, [fetchNotificationElements]);

  return {
    groupedNotificationElements
  };
};
